<!-- 收集活动详情页 -->
<template>
  <div>
    <div>
      <i class="el-icon-arrow-left"
         style="color:#5aabff; font-weight:800"></i>
      <el-button @click="back"
                 type="text"
                 size="small"
                 style="font-weight:800">返回</el-button>
    </div>
    <el-card class="box-card">
      <div class="content">
        <div class="content_left">
          <div style="white-space: nowrap;">封面:</div>
          <div><img :src="this.$url +collectActivityInfoResList.cover"
                 alt="封面"
                 style="width: 100%; margin-left: 10px; border: 1px solid #eee;"></div>
        </div>
        <div class="content_right">
          <div class="content_centre">
            <div>活动名称:</div>
            <div class="name">{{collectActivityInfoResList.title}}</div>
          </div>
          <div class="content_centre">
            <div>活动时间:</div>
            <div class="time">{{collectActivityInfoResList.startTime}}</div>
            <div style="margin-left:10px">到</div>
            <div class="time">{{collectActivityInfoResList.endTime}}</div>
          </div>
          <div class="content_centre">
            <div style="white-space: nowrap;">活动内容:</div>
            <div class="word">
              {{collectActivityInfoResList.content}}
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-button type="success"
                   v-if="collectingActivitiesAuth>1"
                   @click="modifyCollectActivity()">修改收集活动</el-button>
        <el-button type="primary"
                   @click="exportCollectActivityInfo()">导出报名记录</el-button>
      </div>
    </el-card>
    <!-- 修改活动 -->
    <template>
      <el-dialog title="修改活动"
                 :visible.sync="discountDialogs"
                 width="50%">
        <div class="demo-input-suffix">
          <el-form :model="modifyCollectActivityList"
                   ref="modifyCollectActivityList"
                   :rules="rules"
                   label-width="100px">
            <el-form-item label="标题"
                          prop="title">
              <el-input v-model="modifyCollectActivityList.title"
                        placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="活动时间"
                          prop="data"
                          required>
              <el-date-picker v-model="modifyCollectActivityList.data"
                              value-format="yyyy-MM-dd HH:mm"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="内容">
              <el-input v-model="modifyCollectActivityList.content"
                        placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="封面"
                          prop="cover">
              <el-upload class="avatar-uploader"
                         action="api/admin/common/uploadTempFile"
                         :headers="headers"
                         :show-file-list="false"
                         :on-success="handleUploadSuccess"
                         :on-error="handleUploadError"
                         :before-upload="beforeUpload">
                <img v-if="modifyCollectActivityList.cover"
                     :src="this.$url +modifyCollectActivityList.cover"
                     class="avatar"
                     alt="上传的图片">
                <i v-else
                   class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="discountDialogs = false">取 消</el-button>
          <el-button type="success"
                     @click="submitModifyCollectActivity('modifyCollectActivityList')">提交</el-button>
        </span>
      </el-dialog>
    </template>
    <el-card class="box-card">
      <!-- (CURD)操作按钮 -->
      <!-- 表格区域 -->
      <el-table :data="collectActivityInfoInfoRes"
                align="center"
                style="width: 100%"
                :header-cell-style="{background: '#f8f8f9'}">
        <el-table-column prop="name"
                         align="center"
                         label="姓名">
        </el-table-column>
        <el-table-column prop="phone"
                         align="center"
                         label="手机号">
        </el-table-column>
        <el-table-column prop="age"
                         align="center"
                         label="年龄">
        </el-table-column>
        <el-table-column prop="gender"
                         align="center"
                         label="性别">
          <template slot-scope="scope">
            {{scope.row.gender==0?'男':'女'}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime"
                         align="center"
                         label="报名时间">
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js'
export default {
  data() {
    var checkData = (rule, value, callback) => {
      if (value == '') {
        return callback(new Error('请选择活动时间'))
      } else if (value == null) {
        return callback(new Error('请选择活动时间'))
      }

      callback()
    }
    return {
      headers: {
        token: sessionStorage.getItem('token')
      },
      // 修改对话框
      discountDialogs: false,
      collectActivityId: '',
      collectActivityInfoInfoRes: [],
      collectActivityInfoResList: {},
      modifyCollectActivityList: {
        id: '',
        title: '',
        data: [],
        content: '',
        cover: '',
        hasImage: false
      },
      modifyCollectActivityParameters: {
        id: '',
        title: '',
        startTime: '',
        content: '',
        cover: ''
      },
      rules: {
        title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
        data: [{ validator: checkData, required: true, trigger: 'change' }],
        cover: [{ required: true, message: '请上传活动封面', trigger: 'change' }]
      },

      collectingActivitiesAuth: ''
    }
  },
  created() {
    this.collectActivityId = this.$route.query.collectActivityId
    this.getCollectActivityInfo()
    this.getAuthAttr()
  },
  methods: {
    async exportCollectActivityInfo() {
      const _this = this // 保存this指向，避免在回调中丢失
      try {
        const response = await this.$http.get(`/admin/collect_activity/exportCollectActivityInfo?collectActivityId=${this.collectActivityId}`, { responseType: 'blob' })
        const fileReader = new FileReader()
        fileReader.readAsText(response.data, 'utf-8')

        fileReader.onload = function () {
          try {
            // 尝试解析为JSON错误信息
            const result = JSON.parse(this.result)
            _this.$notify({
              title: '批量下载报告',
              message: result.msg || '导出失败，请稍后重试',
              type: 'error',
              duration: 3000
            })
          } catch (error) {
            // 解析失败，视为文件流处理
            const blob = new Blob([response.data])
            const url = URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.style.display = 'none'
            link.download = '报告.xlsx'
            link.href = url

            document.body.appendChild(link)
            link.click()

            // 清理资源
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
          }
        }

        fileReader.onerror = function () {
          _this.$notify({
            title: '错误',
            message: '文件读取失败，请稍后重试',
            type: 'error',
            duration: 3000
          })
        }
      } catch (error) {
        console.error('导出活动信息失败:', error)
        _this.$notify({
          title: '错误',
          message: '导出活动信息时发生错误',
          type: 'error',
          duration: 3000
        })
      }
    },
    // 自定义图片验证函数
    validateImage(rule, value, callback) {
      if (!this.modifyCollectActivityList.cover) {
        // 没有上传图片时返回错误信息
        callback(new Error('请上传图片'))
      } else {
        // 已上传图片则验证通过
        callback()
      }
    },

    // 上传成功处理
    handleUploadSuccess(response) {
      console.log('handleUploadSuccess')
      // 假设接口返回格式为 { code: 200, data: { url: '图片地址' } }
      if (response.code === 200) {
        this.modifyCollectActivityList.cover = response.data
        console.log(this.modifyCollectActivityList.cover)
        this.modifyCollectActivityList.hasImage = true
        // 通知表单验证状态更新
        this.$refs.modifyCollectActivityList.validateField('cover')
      }
    },

    // 上传失败处理
    handleUploadError() {
      this.modifyCollectActivityList.hasImage = false
      this.$message.error('图片上传失败，请重试')
    },

    // 上传前校验（可选，用于限制文件类型和大小）
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件！')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！')
        return false
      }
      return true
    },

    // 提交表单
    submitModifyCollectActivity(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.discountDialogs = false
          this.modifyCollectActivityParameters.title = this.modifyCollectActivityList.title
          this.modifyCollectActivityParameters.startTime = this.modifyCollectActivityList.data[0]
          this.modifyCollectActivityParameters.endTime = this.modifyCollectActivityList.data[1]
          this.modifyCollectActivityParameters.content = this.modifyCollectActivityList.content
          this.modifyCollectActivityParameters.cover = this.modifyCollectActivityList.cover
          const { data: res } = await this.$http.post(`/admin/collect_activity/modifyCollectActivity`, this.modifyCollectActivityParameters)
          if (res.code == 200) {
            this.getCollectActivityInfo()
            this.$message.success('修改收集活动成功')
          } else {
            this.$message.warning(res.msg)
          }
          // 这里写实际提交逻辑
        } else {
          this.$message.error('表单验证失败，请检查必填项')
          return false
        }
      })
    },
    modifyCollectActivity() {
      this.modifyCollectActivityList.title = this.collectActivityInfoResList.title
      this.modifyCollectActivityList.content = this.collectActivityInfoResList.content
      this.modifyCollectActivityList.cover = this.collectActivityInfoResList.cover
      this.modifyCollectActivityParameters.id = this.collectActivityInfoResList.id
      this.modifyCollectActivityList.data[0] = this.collectActivityInfoResList.startTime
      this.modifyCollectActivityList.data[1] = this.collectActivityInfoResList.endTime
      this.discountDialogs = true
    },

    // 获取权限
    getAuthAttr() {
      var collectingActivitiesAuth = window.sessionStorage.getItem('auth-18')
      this.collectingActivitiesAuth = collectingActivitiesAuth
    },
    // 详情
    async getCollectActivityInfo() {
      const { data: res } = await this.$http.get(`/admin/collect_activity/getCollectActivityInfo?collectActivityId=${this.collectActivityId}`)
      if (res.code == 200) {
        this.collectActivityInfoResList = res.data
        this.collectActivityInfoInfoRes = res.data.collectActivityInfoInfoRes
      } else {
        this.$message.error(res.msg)
      }
    },
    // 返回用户列表
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang='scss' scoped>
.content {
  display: flex;
  justify-content: space-around;
  .content_left {
    width: 40%;
    display: flex;
    line-height: 40px;
    .name {
      margin-left: 10px;
      font-weight: 600;
    }
  }
  .content_right {
    width: 40%;
    .content_centre {
      display: flex;
      line-height: 40px;
      .name {
        margin-left: 10px;
        font-weight: 600;
      }
      .time {
        margin-left: 10px;
      }
      .word {
        word-break: break-all;
        word-wrap: break-word;
      }
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>